import * as Yup from 'yup';
import moment from 'moment';

import {
  CreateSubmissionField,
  getSubmissionFieldRequiredErrorMessage,
  getSubmissionFieldWrongTypeErrorMessage,
} from '@converge/data';

export const stringRequired = (fieldName: CreateSubmissionField) => {
  return Yup.string()
    .typeError(getSubmissionFieldWrongTypeErrorMessage(fieldName))
    .required(getSubmissionFieldRequiredErrorMessage())
    .trim()
    .min(1, getSubmissionFieldRequiredErrorMessage());
};

export const ratedRevenueRequired = (fieldName: CreateSubmissionField) => {
  return Yup.mixed()
    .typeError(getSubmissionFieldWrongTypeErrorMessage(fieldName))
    .required('This field is required and must be more than 0')
    .test(
      'ratable-revenue-validation',
      'This field is required and must be more than 0',
      function (value) {
        // Require non-empty values greater than 0
        if (value === null || value === undefined || value === '') {
          return false; // Still required
        }

        // Convert to string and trim
        const stringValue = String(value).trim();

        // Only allow valid positive numbers (greater than 0)
        if (
          stringValue &&
          !isNaN(Number(stringValue)) &&
          Number(stringValue) > 0
        ) {
          return true;
        }

        return false;
      }
    );
};

export const insuredEntity = Yup.object().shape({
  primaryLegalAlias: Yup.object().shape({
    name: stringRequired(CreateSubmissionField.LegalName),
  }),
  primaryFundamentals: Yup.object().shape({
    revenue: stringRequired(CreateSubmissionField.CurrentDomesticRevenue),
    ratedRevenueOverride: ratedRevenueRequired(
      CreateSubmissionField.RatedRevenueOverride
    ),
  }),
});

export const createSubmissionFieldsSchema = Yup.object({
  // capacityProviderUuid: stringRequired(CreateSubmissionField.CapacityProvider),
  type: stringRequired(CreateSubmissionField.Type),
  effectiveDate: Yup.string().nullable(),
  expirationDate: Yup.string()
    .nullable()
    .test(
      'expiration-after-effective',
      'Expiration date must be after the effective date',
      function (value) {
        const { effectiveDate } = this.parent;
        if (!value || !effectiveDate) {
          return true;
        }
        return moment(effectiveDate)
          .add(1, 'day')
          .isBefore(moment(value), 'day');
      }
    ),
});
